<template>
  <order-progress-chip v-if="cardError" :status="cardError" />
</template>

<script>
import OrderProgressChip from '@/components/OrderProgressChip.vue'

export default {
  props: ['card'],

  components: { OrderProgressChip },

  computed: {
    cardError() {
      const findStatus = () => {
        // In cases of Apple pay or wechat, we are handed strings not objects.
        // Only Credit cards can have errors
        if (typeof this.card == 'object')
          // hard coded options for credit card erors provided from the api
          return ['cvcFailed', 'postalCodeFailed', 'expiredCard'].find(error => this.card[error])
        return null
      }

      const status = findStatus()

      if (!!status)
        this.$emit('CardError', status)

      return status
    }
  }
}
</script>
